import {Pipe, PipeTransform} from "@angular/core";

interface IHeaders {
	field?: string;
	label?: string;
	type?: string;
	choices?: any[];
	op?: string;
	data?: any;
}

@Pipe({name: "dateTimeConverter"})
export class DateTimeConverterPipe implements PipeTransform {
	transform(value: IHeaders): any {
		if (value.data instanceof Date) {
			return value;
		} else {
			let d = value.data.split(".")[0];
			value.data = new Date(d);
			return value;
		}
	}
}
